import { useEffect } from "react";
import useReveal from "@/hooks/useReveal";
import Hero from "@/components/landing/Hero";
import Pain from "@/components/landing/Pain";
import BeliefBreak from "@/components/landing/BeliefBreak";
import Solution from "@/components/landing/Solution";
import Benefits from "@/components/landing/Benefits";
import HowItWorks from "@/components/landing/HowItWorks";
import Included from "@/components/landing/Included";
import Authority from "@/components/landing/Authority";
import Offer from "@/components/landing/Offer";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import StickyMobileCTA from "@/components/landing/StickyMobileCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
    useReveal();

    useEffect(() => {
        document.title = "Inglês Destravado em 30 Dias · Método dos Poliglotas";
    }, []);

    return (
        <main data-testid="landing-page" className="bg-cream">
            <Hero />
            <Pain />
            <BeliefBreak />
            <Solution />
            <Benefits />
            <HowItWorks />
            <Included />
            <Authority />
            <Offer />
            <FAQ />
            <FinalCTA />
            <Footer />
            <StickyMobileCTA />
        </main>
    );
}
